import React,{FC} from 'react';
import MgpIcon from '../MgpIcon/MgpIcon';
import { MgpButtonProps } from './MgpButton.types';



export default function MgpButton ({ variant, text, color, size, icon, iconPosition = 'left', loading, ...props }: MgpButtonProps) {
    if(!color) {
        color = "bleu";
    }
    let btnClassName;
    if(variant && variant === "inline") {
      btnClassName = "cta-inline cta-inline-" + color + (size == "small" ? " cta-small":"") + ( icon? " withicon":"");
    } else if(variant && variant === "inverse") {
      btnClassName =  "cta-" + color + (size == "small" ? " cta-small":"") + ( icon? " withicon":"") + " inverse";
    }  
    else {
      btnClassName = "cta-" + color + (size == "small" ? " cta-small":"") + ( icon? " withicon":"");
    }
     
    return (
      <>
      <button className={btnClassName} {...props}>
        {icon && iconPosition ==='left' ? <MgpIcon icon={icon}/>:""}
        {props.children?props.children:text}
        {icon && iconPosition ==='right' ? <MgpIcon icon={icon}/>:""}
        {loading&&<span className='mgp-spinner'></span>}
      </button>
      
      </>
    );
  };
